import { forwardRef, type Ref, type SVGProps } from "react";
const IconPlayCircleFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2m5.5 14.8-8 5A1 1 0 0 1 12 21V11a1 1 0 0 1 1.5-.8l8 5a1 1 0 0 1 0 1.6" /></svg>;
const ForwardRef = forwardRef(IconPlayCircleFilledSVG);
ForwardRef.displayName = "IconPlayCircleFilled";
export { ForwardRef as IconPlayCircleFilled };